import { cn } from './cn';

export const InstructionsIcon = ({ className }: { className?: string }) => {
  return (
    <svg viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" className={cn('size-5', className)}>
      <path
        d="M2.42578 14.3783L2.42578 4.16919C2.42578 2.76016 3.56768 1.61826 4.97672 1.61826H13.7721C14.1924 1.61826 14.5336 1.95858 14.5336 2.37882V16.1687C14.5336 16.5889 14.1924 16.9292 13.7721 16.9292H10.6444V15.4081H13.0116V3.13938H4.97672C4.40816 3.13938 3.9469 3.60064 3.9469 4.16919V14.3783C3.9469 14.9469 4.40816 15.4081 4.97672 15.4081V16.9292C3.56768 16.9292 2.42578 15.7873 2.42578 14.3783Z"
        fill="#111111"
      />
      <path
        d="M2.49199 14.1533C2.49199 13.4424 2.66131 12.7721 3.2166 12.2833C3.72591 11.8351 4.44011 11.6542 5.22624 11.5639C6.03253 11.4712 7.06926 11.4602 8.34627 11.4694C9.64157 11.4788 11.1936 11.5097 13.1006 11.5097L13.1006 13.0317C11.1907 13.0317 9.60258 12.9998 8.33497 12.9906C7.04928 12.9812 6.09984 12.9955 5.39741 13.0762C4.67496 13.1593 4.35746 13.3008 4.2123 13.4285C4.11324 13.5158 4.00465 13.675 4.00465 14.1533L2.49199 14.1533Z"
        fill="#111111"
      />
      <path
        d="M9.82499 17.8319V14.1332C9.82499 14.0424 9.74992 13.9688 9.65732 13.9688H6.4997C6.4071 13.9688 6.33203 14.0424 6.33203 14.1332V17.8352C6.33203 17.9715 6.49168 18.0486 6.60194 17.9654L7.98958 16.9191C8.05024 16.8733 8.13481 16.8737 8.19511 16.9199L9.55403 17.9613C9.6641 18.0457 9.82499 17.9688 9.82499 17.8319Z"
        fill="#111111"
      />
      <rect x="5.6709" y="4.53699" width="5.73287" height="1.19828" rx="0.599139" fill="#111111" />
      <rect x="6.49609" y="7.0043" width="4.08217" height="1.2556" rx="0.627798" fill="#111111" />
    </svg>
  );
};
